import ServiceBase from "base/baseService"

export default class CbsCstService extends ServiceBase {

    title = "CST da CBS"
    pluralTitle = "CSTs da CBS"
    url = '/cadastro/fiscal/cbscst'
    frontUrl = '/cadastro/fiscal/cbscst'
    frontUrlList = '/cadastro/fiscal/cbscstlist'
    primaryKey = 'codigo_cbscst'
    ignoredsSchemaConvertions = []

    prepareToFront(data = {}) {

        // Strings notNullable
        data.codigo_cbscst = data?.codigo_cbscst || ''
        data.descricao_cbscst = data?.descricao_cbscst || ''

        return data
    }

    prepareToSave({ data }) {
        return data
    }

}
